var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.onClick}},[_c('i',{staticClass:"mdi v-icon",class:{
      'mdi-checkbox-marked': _vm.params.value,
      'mdi-checkbox-blank-outline': !_vm.params.value,
    },style:({
      cursor: _vm.cursor,
      opacity: _vm.opacity,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }